/* eslint-disable */
import $ from "jquery";

export const initializeAvatars = function (vm) {

  let finalGender = null;

  $('#default-avatar').click(function (e) {
    e.preventDefault();
    console.log('Default Avatar choice for Male Gender');
    if (vm.userDetails.displayAvatar) {
      if (vm.userDetails.facebookImage) {
        vm.updateDisplayAvatar();
      } else {
        localStorage.setItem('Avatar', 'static/images/avatar_default.png');
        vm.sendAvatarCall(finalGender);
      }
    }
    vm.$router.push({ name: 'profileDefault' });
  });

  $('#default-avatar-female').click(function (e) {
    e.preventDefault();
    console.log('Default Avatar choice for FeMale Gender');
    if (vm.userDetails.displayAvatar) {
      if (vm.userDetails.facebookImage) {
        vm.updateDisplayAvatar();
      } else {
        localStorage.setItem('Avatar', 'static/images/avatar_default.png');
        vm.sendAvatarCall(finalGender);
      }
    }
    vm.$router.push({ name: 'profileDefault' });
  });

  $('.tab-header a').click(function (e) {
    e.preventDefault();
    const $this = $(this);
    const target = $this.data('target');
    if (!$this.hasClass('active')) {
      $('.tab-header a').removeClass('active');
      $this.addClass('active');
      $('.tab-container__item.active').fadeOut(200, function () {
        $('.tab-container__item').removeClass('active');
        $('#' + target).fadeIn(200, function () {
          $(this).addClass('active');
        });
      });
    }
  });

  $('.select-edit-avatar a').click(function (e) {
    e.preventDefault();
    const gender = $(this).data('gender');
    finalGender = gender;
    let callback;
    if (gender === "male") {
      callback = function () {
        $('#studio_male').fadeIn(200);
        $('#studio_female').fadeOut(200);
        $('#female .select-edit-avatar').fadeIn();
      }
    }
    else if (gender === "female") {
      callback = function () {
        $('#studio_female').fadeIn(200);
        $('#studio_male').fadeOut(200);
        $('#male .select-edit-avatar').fadeIn();
      };
    }
    $(this).parent().fadeOut(200, callback);
    initAvatarState(gender);
    initCanvas(window.avatarState.avatar.gender);
  });

  $('.studio_nav a').click(function (e) {
    e.preventDefault();
    const countImages = avatarImages[window.avatarState.edit][window.avatarState.avatar.gender].length;
    const direction = $(this).data('value');
    if (direction === "prev") {
      currentItem--;
    }
    else if (direction === "next") {
      currentItem++;
    }
    if (currentItem < 0) {
      currentItem = countImages - 1;
    }
    if (currentItem >= countImages) {
      currentItem = 0;
    }
    window.avatarState.avatar[window.avatarState.edit] = avatarImages[window.avatarState.edit][window.avatarState.avatar.gender][currentItem].value;

    if (vm.isAvatarGroupWithoutAccessories) {
      updateCanvasWithoutAccessories();
    } else {
      updateCanvas();
    }
  });

  $('.avatar-option').click(function (e) {
    e.preventDefault();
    $('.avatar-option').removeClass('active');
    $(this).addClass('active');
    window.avatarState.edit = $('a', this).data('value');
    currentItem = 0;
  });

  $('.save-btn').click(function (e) {
    e.preventDefault();
    $(this).attr('href', canvas.toDataURL("image/png"));
    localStorage.setItem('Avatar', canvas.toDataURL("image/png"));
    vm.sendAvatarCall(finalGender).then(() => {
      if (!vm.userDetails.displayAvatar) {
        vm.updateDisplayAvatar();
      }
      vm.$router.push('/home/profile');
    });
  });

  let canvas;
  let ctx;
  let currentItem = 0;
  const skin = new Image;
  const hair = new Image;
  const mustage = new Image;
  const accessory = new Image;
  const jewellery = new Image;
  const avatarImages = [];

  const initAvatarState = function (gender) {
    if (vm.isAvatarGroupWithoutAccessories) {
      window.avatarState = {
        edit: 'hair',
        avatar: {
          gender: gender,
          hair: 'single',
        }
      };
    } else {
      window.avatarState = {
        edit: 'hair',
        avatar: {
          gender: gender,
          hair: 'brown',
          skin: 'white',
          mustage: '',
          accessory: '',
          jewellery: ''
        }
      };
      // EXC-2833
      if (vm.avatarGrouping === 8) {
        window.avatarState.avatar.skin = 'white';
        if (gender === 'male') {
          window.avatarState.avatar.hair = 'white2';
        } else {
          window.avatarState.avatar.hair = 'black';
        }
      }
    }
  };

  const initCanvas = function (gender) {
    console.log(gender);
    canvas = $('.canvas_avatar--' + gender)[0];
    ctx = canvas.getContext("2d");
    if (vm.isAvatarGroupWithoutAccessories) {
      updateCanvasWithoutAccessories();
    } else {
      updateCanvas();
    }
    getImages();
  };

  const getImages = function () {
    var temp = [];
    temp['female'] = [];
    temp['male'] = [];
    $(".skin > img").each(function () {
      if ($(this).data('gender')) {
        temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
      }
    });
    avatarImages['skin'] = temp;
    temp = [];
    temp['female'] = [];
    temp['male'] = [];
    $(".hair > img").each(function () {
      if ($(this).data('gender')) {
        temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
      }
    });
    avatarImages['hair'] = temp;
    temp = [];
    temp['female'] = [];
    temp['male'] = [];
    $(".mustage > img").each(function () {
      if ($(this).data('gender')) {
        temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
      }
    });
    avatarImages['mustage'] = temp;
    temp = [];
    temp['female'] = [];
    temp['male'] = [];
    $(".jewellery > img").each(function () {
      if ($(this).data('gender')) {
        temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
      }
    });
    avatarImages['jewellery'] = temp;
    temp = [];
    temp['female'] = [];
    temp['male'] = [];
    $(".accessory > img").each(function () {
      if ($(this).data('gender')) {
        temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
      }
    });
    avatarImages['accessory'] = temp;
    console.log(avatarImages);
  };

  const updateCanvas = function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvasSkin();
  };

  const updateCanvasWithoutAccessories = function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvasHairWithoutAccessories();
  };

  const canvasHairWithoutAccessories = function () {
    hair.onload = function () {
      ctx.drawImage(this,
        canvas.width / 2 - hair.width / 2,
        canvas.height / 2 - hair.height / 2,
        this.width,
        this.height
      );
    };
    var image_path = $(".hair [data-value='" + window.avatarState.avatar.hair + "']").filter(".hair [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
    hair.src = image_path;
  };

  const canvasSkin = function () {
    skin.onload = function () {
      ctx.drawImage(this,
        canvas.width / 2 - skin.width / 2,
        canvas.height / 2 - skin.height / 2,
        this.width,
        this.height
      );
      canvasHair();
    };
    skin.src = $(".skin [data-value='" + window.avatarState.avatar.skin + "']").filter(".skin [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
  };

  const canvasHair = function () {
    hair.onload = function () {
      ctx.drawImage(this,
        canvas.width / 2 - hair.width / 2,
        canvas.height / 2 - hair.height / 2,
        this.width,
        this.height
      );
      canvasMustage();
    };
    hair.src = $(".hair [data-value='" + window.avatarState.avatar.hair + "']").filter(".hair [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
  };

  const canvasMustage = function () {
    mustage.onload = function () {
      ctx.drawImage(this,
        canvas.width / 2 - hair.width / 2,
        canvas.height / 2 - hair.height / 2,
        this.width,
        this.height
      );
      canvasAccessory();
    };
    canvasAccessory();
    const image_path = $(".mustage [data-value='" + window.avatarState.avatar.mustage + "']").filter(".mustage [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
    if (image_path) mustage.src = image_path;
  };

  const canvasAccessory = function () {
    accessory.onload = function () {
      ctx.drawImage(this,
        canvas.width / 2 - hair.width / 2,
        canvas.height / 2 - hair.height / 2,
        this.width,
        this.height
      );
      canvasJewellery();
    };
    canvasJewellery();
    const image_path = $(".accessory [data-value='" + window.avatarState.avatar.accessory + "']").filter(".accessory [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
    if (image_path) accessory.src = image_path;
  };

  const canvasJewellery = function () {
    jewellery.onload = function () {
      ctx.drawImage(this,
        canvas.width / 2 - hair.width / 2,
        canvas.height / 2 - hair.height / 2,
        this.width,
        this.height
      );
    };
    const image_path = $(".jewellery [data-value='" + window.avatarState.avatar.jewellery + "']").filter(".jewellery [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
    if (image_path) jewellery.src = image_path;
  };
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/common/avatarHelper.js